import { getApi, getEncodedSearchString, postApi } from "../../common/actions/net.js";
import { getExistingProductImage, loadProductImage } from "../../kundeweb/actions/productImage.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";
import Logger from "../../common/util/Logger.js";

export const SET_SINGLE_EPIX_SORTIMENT = "SET_SINGLE_EPIX_SORTIMENT";
export const ADD_SINGLE_EPIX_SORTIMENT = "ADD_SINGLE_EPIX_SORTIMENT";
export const SET_QUERY_PRODUCT_IMAGE_URL = "SET_QUERY_PRODUCT_IMAGE_URL";
export const SINGLE_EPIX_SORTIMENT_IS_LOADING = "SINGLE_EPIX_SORTIMENT_IS_LOADING";
export const SINGLE_EPIX_QUERY_DONE_LOADING = "SINGLE_EPIX_QUERY_DONE_LOADING";
export const SINGLE_EPIX_QUERY_FAILED_LOADING = "SINGLE_EPIX_QUERY_DONE_LOADING";
export const SINGLE_EPIX_QUERY_ALL_LOADED = "SINGLE_EPIX_QUERY_ALL_LOADED";
export const EDIT_SINGLE_EPIX_FILTER = "EDIT_SINGLE_EPIX_FILTER";
export const CLEAR_SINGLE_EPIX_SORTIMENT = "CLEAR_SINGLE_EPIX_SORTIMENT";
export const SET_SINGLE_EPIX_SORTIMENT_FILTER = "SET_SINGLE_EPIX_SORTIMENT_FILTER";

export const SET_SINGLE_EPIX_PRODUCT_DETAIL = "SET_SINGLE_EPIX_PRODUCT_DETAIL";
export const CLEAR_SINGLE_EPIX_PRODUCT_DETAIL = "CLEAR_SINGLE_EPIX_PRODUCT_DETAIL";
export const UPDATE_SINGLE_EPIX_PRODUCT_LIST = "UPDATE_SINGLE_EPIX_PRODUCT_LIST";
export const SET_INVOICE_GROUPS = "SET_INVOICE_GROUPS";
export const SET_QUERY_OPTION = "SET_QUERY_OPTION";

const setQueryProductImageUrl = (index, imageUrl) => ({
    type: SET_QUERY_PRODUCT_IMAGE_URL,
    index,
    imageUrl
});

const setSingleEpixSortimentIsLoading = () => ({
    type: SINGLE_EPIX_SORTIMENT_IS_LOADING
});
const setSingleEpixSortimentDoneLoading = () => ({
    type: SINGLE_EPIX_QUERY_DONE_LOADING
});
const setSingleEpixSortimentFailedLoading = () => ({
    type: SINGLE_EPIX_QUERY_FAILED_LOADING
});

const setSingleEpixSortimentAllLoaded = () => ({
    type: SINGLE_EPIX_QUERY_ALL_LOADED
});

/**
 * Downloads more single chain Epix sortiment items
 * @param {object} singleEpixSortiment
 * @param {object} productImage
 * @param {number} noOfProducts
 * @returns {func}
 */
export function loadMoreSingleEpixSortiment(singleEpixSortiment, productImage, noOfProducts = 50) {
    return async (dispatch, getState) => {
        try {
            //make sure there is something new to load
            if (singleEpixSortiment.allResultsLoaded) {
                return;
            }

            //start collection new lines
            dispatch(setSingleEpixSortimentIsLoading());

            const startIndex = singleEpixSortiment.allProducts.length;

            // Load in more products
            const { payload } = await dispatch(
                getApi("Chain/ProductsFreeTextQuery", {
                    chainType: getState().authentication.chainType,
                    onlyAvailableForChain: false,
                    noOfProducts: noOfProducts,
                    startIndex: startIndex,
                    freeText: getEncodedSearchString(singleEpixSortiment.chainFilter.searchString),
                    supplierId: singleEpixSortiment.chainFilter.supplierId ? singleEpixSortiment.chainFilter.supplierId : undefined,
                    productGroupId: singleEpixSortiment.chainFilter.productGroupId ? singleEpixSortiment.chainFilter.productGroupId : undefined,
                    InvoiceGroup:  singleEpixSortiment.chainFilter.invoiceGroupId ? singleEpixSortiment.chainFilter.invoiceGroupId : undefined,
                    ProductStatus: singleEpixSortiment.chainFilter.productStatus >= 0 ? singleEpixSortiment.chainFilter.productStatus : undefined,
                    onlyNews: singleEpixSortiment.chainFilter.onlyNews,
                })
            );

            // Check if all data has been loaded
            if (payload.products.length != noOfProducts) {
                dispatch(setSingleEpixSortimentAllLoaded());
            }

            // Insert existing images
            for (let i = 0; i < payload.products.length; i++) {
                payload.products[i].imageUrl = getExistingProductImage(payload.products[i].productId);
            }
            // Convert to default layout
            const prdList = payload.products.map(prd => {
                return { product: prd };
            });

            // Store query results
            await dispatch({ type: ADD_SINGLE_EPIX_SORTIMENT, allProducts: prdList });

            // Download all images not already inserted
            for (let index = 0; index < prdList.length; index++) {
                if (!prdList[index].product.imageUrl || prdList[index].product.imageUrl.length === 0) {
                    const callback = imageUrl => dispatch(setQueryProductImageUrl(startIndex + index, imageUrl));
                    dispatch(loadProductImage(productImage, prdList[index].product.productId, prdList[index].product.imageFileName, callback));
                }
            }

            dispatch(setSingleEpixSortimentDoneLoading());
        } catch (error) {
            dispatch(setSingleEpixSortimentFailedLoading());
            dispatch(pushSystemMessage(error && error.message || "Søket mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Changes the query filter
 * @param {object} change
 * @param {func}   callback // function will be called when the state has been updated
 * @returns {func}
 */
export function editSingleEpixFilter(change, callback) {
    return async dispatch => {
        await dispatch({
            type: EDIT_SINGLE_EPIX_FILTER,
            change
        });

        try {
            dispatch(setSingleEpixSortimentIsLoading());
            await callback();
        } catch (error) {
            Logger.error(error);
        } finally {
            dispatch(setSingleEpixSortimentDoneLoading());
        }
    };
}

/**
 * Clears the single chain Epix sortiment
 * @returns {func}
 */
export function clearSingleEpixSortiment() {
    return async dispatch => {
        dispatch({
            type: CLEAR_SINGLE_EPIX_SORTIMENT
        });
    };
}

/**
 * Sets the single chain Epix sortiment filter "OnlyAvailableForChain" flag
 * @param {object} change
 * @returns {func}
 */
export function setSingleEpixSortimentFilter(change) {
    return async dispatch => {
        dispatch({
            type: SET_SINGLE_EPIX_SORTIMENT_FILTER,
            change
        });
    };
}

/**
 * Changes the query filter
 * @returns {func}
 */
export function prepareQueryOptions() {
    return async (dispatch, getState) => {
        const state = getState();
        const payload = await dispatch(getApi("Chain/FilterOptionsQuery",  {
            chainType: state.authentication.chainType}));
        dispatch({
            type: SET_QUERY_OPTION,
            productGroups: payload ? payload.payload.productGroups : null,
            productSuppliers: payload ? payload.payload.suppliers : null
        });
    };
}

/**
 * Gets product details for the given product id
 * @param {number} chainId
 * @param {string} productId
 * @param {string} imageUrl
 * @returns {function.<string>}
 */
export function getSingleEpixProductDetail(chainId, productId, imageUrl) {
    return async dispatch => {
        try {
            // Call webApi to make Products details request
            const { payload: productDetail } = await dispatch(getApi("Chain/ProductsDetailQuery", { chainId, productId }));
            productDetail.imageUrl = imageUrl;

            dispatch({
                type: SET_SINGLE_EPIX_PRODUCT_DETAIL,
                productDetail
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av varedetaljer mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Clears chain product detail modal
 * @returns {function.<string>}
 */
export function clearEpixProductDetails() {
    return async dispatch => {
        try {
            dispatch({
                type: CLEAR_SINGLE_EPIX_PRODUCT_DETAIL
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Gets invoice groups
 * @returns {function.<string>}
 */
export function getInvoiceGroups() {
    return async dispatch => {
        try {
            // Call webApi to get a list of invoice groups
            const { payload: invoiceGroups } = await dispatch(getApi("Chain/InvoiceGroupsQuery"));

            dispatch({
                type: SET_INVOICE_GROUPS,
                invoiceGroups
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av fakturagruppe mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Commit product changes
 * @param {number} chainType
 * @param {array} products
 * @returns {func}
 */
export function updateChainProducts(chainType, products) {
    return async dispatch => {
        try {
            // dispatch({
            //     type: UPDATE_PRODUCTS,
            //     committing: true,
            // });

            const payload = await dispatch(
                postApi("Chain/UpdateChainProductsCommand", {
                    chainType: chainType,
                    productsToUpdate: products.map(p => {
                        return {
                            chainId: p.chainId,
                            productId: p.productId,
                            isAvailable: p.isAvailable,
                            inCatalogue: p.inCatalogue,
                            invoiceGroupId: p.invoiceGroupId,
                            sortimentCode: p.sortimentCode,
                            futureEndPrice: p.futureEndPrice,
                            futureEndPriceDate: p.futureEndPriceDate,
                            futureAdminCharge: p.futureAdminCharge,
                            futureAdminChargeDate: p.futureAdminChargeDate
                        };
                    })
                })
            );

            if (payload && payload.message === "OK") {
                dispatch(pushSystemMessage("Varer ble oppdatert!", messageType.message));
                // history.push("/dashboard");
                // dispatch({
                //     type: CLEAR_CLAIM,
                // });

                // Call reducer that updates the product in the list from free text search
                dispatch({ type: UPDATE_SINGLE_EPIX_PRODUCT_LIST, products });
            } else {
                dispatch(pushSystemMessage(payload && payload.displayMessage || "Kan ikke oppdatere varer", messageType.error));
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Kan ikke oppdatere varer", messageType.error));
            Logger.error(error);
        } finally {
            // dispatch({
            //     type: UPDATE_PRODUCTS,
            //     committing: false,
            // });
        }
    };
}
